module.exports = __webpack_public_path__ + "static/img/雅生石英石水槽色卡.cf3b369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/雅生石英石水槽色卡.jpg
// module id = 3yZI
// module chunks = 1